import { FC } from 'react';
import FormGroup, { FormGroupProps } from 'components/FormGroup';
import CountrySelect, { BaseCountrySelectProps } from 'components/forms/CountrySelect';
import { CustomerInfoKeyType } from 'types/customer';

export interface LegalResidenceCountryFormutil {
    legal_residence_country: string;
}

export const defaultFieldsOfLegalResidenceCountry: CustomerInfoKeyType[] = ['legal_residence_country'];

interface LegalResidenceCountryProps extends FormGroupProps {
    isSSN: boolean;
    disabled?: boolean;
    countrySelectProps?: Omit<BaseCountrySelectProps, 'isSSN'>;
}

/** 居住国表单组件 */
const LegalResidenceCountry: FC<LegalResidenceCountryProps> = ({
    label = __('Country/Region of Permanent Residence'),
    isSSN,
    disabled,
    countrySelectProps,
    ...restProps
}) => {
    const { limitCountryList, ...restCountrySelectProps } = countrySelectProps || {};

    return (
        <FormGroup
            name="legal_residence_country"
            label={label}
            checker={(value: string) => {
                if (disabled) {
                    return true;
                }

                return !!value || __('请选择居住国');
            }}
            {...restProps}>
            <CountrySelect
                isSSN={isSSN}
                disabled={disabled}
                limitCountryList={limitCountryList}
                fieldName="legal_residence_country"
                {...restCountrySelectProps}
            />
        </FormGroup>
    );
};

export default LegalResidenceCountry;
